exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".RightClickMenu[data-v-739c1b1c]{border-radius:4px;background-color:#0b252d!important;z-index:110}.menu_list[data-v-739c1b1c]{border-radius:4px;background-color:#1d444b!important}.active_class[data-v-739c1b1c]{background-color:rgba(0,116,201,.4);color:#00c0ff!important}", ""]);

// exports
